/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EventTopic } from "../../events/types/EventTopic";
import { Compiler } from "./Compiler";
import { AgentTemplateEnum } from "./AgentTemplateEnum";
import { TemplateOptions } from "./TemplateOptions";
export const AgentConfig = core.serialization.object({
    topics: core.serialization.list(EventTopic).optional(),
    compiler: Compiler.optional(),
    source: core.serialization.string().optional(),
    sourceMap: core.serialization.string().optional(),
    slug: core.serialization.string().optional(),
    options: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    template: AgentTemplateEnum.optional(),
    templateOptions: TemplateOptions.optional(),
    isSystem: core.serialization.boolean().optional(),
    namespace: core.serialization.string().optional(),
    packageVersions: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    commitInfo: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
});
